var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.state === 2 || _vm.state === null) ? _c('v-flex-container', {
    attrs: {
      "center": ""
    }
  }, [_c('div', {
    directives: [{
      name: "text-align",
      rawName: "v-text-align.center",
      modifiers: {
        "center": true
      }
    }]
  }, [_c('v-text', {
    attrs: {
      "type": "subheadling",
      "bold": ""
    }
  }, [_vm._v(" Данные устарели ")])], 1)]) : _c('v-flex-container', {
    attrs: {
      "center": ""
    }
  }, [(_vm.isFetching) ? _c('div', [_c('v-spinner', {
    directives: [{
      name: "margin",
      rawName: "v-margin.bottom",
      value: (1),
      expression: "1",
      modifiers: {
        "bottom": true
      }
    }, {
      name: "margin",
      rawName: "v-margin.top",
      value: (1),
      expression: "1",
      modifiers: {
        "top": true
      }
    }],
    attrs: {
      "block": ""
    }
  })], 1) : _c('div', {
    directives: [{
      name: "padding",
      rawName: "v-padding",
      value: (2),
      expression: "2"
    }],
    staticStyle: {
      "max-width": "1024px"
    }
  }, [_c('div', {
    directives: [{
      name: "margin",
      rawName: "v-margin.bottom",
      value: (1),
      expression: "1",
      modifiers: {
        "bottom": true
      }
    }]
  }, [_c('v-text', {
    attrs: {
      "type": "title",
      "bold": ""
    }
  }, [_vm._v("СОГЛАСИЕ ")]), _vm._v(" "), _c('div', [_c('v-text', {
    attrs: {
      "type": "subheadling",
      "bold": "",
      "c": ""
    }
  }, [_vm._v("\n            на получение информации в Бюро кредитных историй и обработку\n            персональных данных\n          ")])], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "margin",
      rawName: "v-margin.bottom",
      value: (1),
      expression: "1",
      modifiers: {
        "bottom": true
      }
    }]
  }, [_c('v-text', [_vm._v("\n          Дата оформления согласия\n          " + _vm._s(_vm.moment(_vm.currentDate).format('DD.MM.YYYY')) + " г.\n          "), _c('br'), _vm._v("\n          Я, (ФИО) " + _vm._s(_vm.subject.lastName) + " " + _vm._s(_vm.subject.fisrtName) + "\n          " + _vm._s(_vm.subject.maiddleName) + "."), _c('br'), _vm._v("\n          Место рождения " + _vm._s(_vm.subject.placeBirth) + "."), _c('br'), _vm._v("\n          Дата рождения " + _vm._s(_vm.moment(_vm.subject.birthDate).format('DD.MM.YYYY')) + " г.,\n          Паспорт серия " + _vm._s(_vm.subject.documentSeries) + " №" + _vm._s(_vm.subject.documentNumber) + ". "), _c('br'), _vm._v("\n          Паспорт выдан " + _vm._s(_vm.moment(_vm.subject.issueDate).format('DD.MM.YYYY')) + " г.\n          "), _c('br'), _vm._v("\n          настоящим выражаю свое согласие на получение ООО\n          «Экспертбизнесконсалтинг» (далее: «Оператор», «ООО «ЭБК») из любого\n          бюро кредитных историй кредитного отчета, содержащего, в том числе,\n          основную часть кредитной истории, в объеме и порядке,\n          предусмотренном Федеральным законом от 30.12.2004г. № 218-ФЗ «О\n          кредитных историях», в целях получения сведений, содержащихся в\n          основной части кредитной истории, для оценки кредитоспособности\n          субъекта и предоставления указанных сведений в\n          «" + _vm._s(_vm.requester.companyName) + "» ИНН:" + _vm._s(_vm.requester.inn) + " (наименование\n          получателя). Настоящее согласие действительно с момента его\n          оформления и считается действительным в течение шести месяцев.\n        ")])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "margin",
      rawName: "v-margin.bottom",
      value: (1),
      expression: "1",
      modifiers: {
        "bottom": true
      }
    }]
  }, [_c('v-text', [_c('strong', [_vm._v("\n            Обработка данных осуществляется в информационной системе «Exbico\n            2.0», принадлежащей ООО «ЭБК».")])])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "margin",
      rawName: "v-margin.bottom",
      value: (1),
      expression: "1",
      modifiers: {
        "bottom": true
      }
    }]
  }, [_c('v-text', [_vm._v("\n          Согласие на обработку персональных данных дается мною в целях\n          получения услуг, оказываемых Оператором, для проверки\n          кредитоспособности, своевременности выполнения мной кредитных\n          обязательств перед кредитными организациями для оценки моей\n          благонадежности «" + _vm._s(_vm.requester.companyName) + "»\n          ИНН:" + _vm._s(_vm.requester.inn) + "(наименования получателя). В соответствии с\n          Федеральным законом от 27.07.2006г. № 152-ФЗ «О персональных\n          данных», я даю согласие Оператору на обработку моих персональных\n          данных (фамилия, имя, отчество, год, месяц, дата и место рождения;\n          адрес, номер паспорта и сведения о дате выдачи паспорта и выдавшем\n          его органе; образование, профессия, место работы и должность;\n          домашний, рабочий и мобильный телефоны, адрес электронной почты,\n          сведения из кредитной истории и т.д.)\n        ")])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "margin",
      rawName: "v-margin.bottom",
      value: (1),
      expression: "1",
      modifiers: {
        "bottom": true
      }
    }]
  }, [_c('v-text', [_vm._v("\n          Я проинформирован(а), что под обработкой персональных данных\n          понимаются действия (операции) с персональными данными в рамках\n          Федерального закона №152-ФЗ от 27.07.2006 г. как с использованием\n          средств автоматизации, так и без использования таковых и включает в\n          себя сбор, систематизацию, накопление, хранение, уточнение\n          (обновление, изменение), использование, предоставление,\n          обезличивание, блокирование, уничтожение персональных данных,\n          передача персональных данных «" + _vm._s(_vm.requester.companyName) + "»\n          ИНН:" + _vm._s(_vm.requester.inn) + " (наименование получателя). Конфиденциальность\n          персональных данных соблюдается Оператором в рамках законодательства\n          Российской Федерации. Передача персональных данных третьим лицам,\n          которым Оператор передает соответствующие персональные данные для\n          достижения указанных выше целей, производится Оператором при\n          обязательном условии обеспечения данными лицами безопасности\n          предоставленных выше персональных данных.\n        ")])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "margin",
      rawName: "v-margin.bottom",
      value: (1),
      expression: "1",
      modifiers: {
        "bottom": true
      }
    }]
  }, [_c('v-text', [_vm._v("\n          Я выражаю согласие на направление на мой номер телефона, указанный в\n          Согласиях, СМС-сообщений и/или звонков с информацией рекламного\n          характера об услугах Оператора, партнеров Оператора.\n        ")])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "margin",
      rawName: "v-margin.bottom",
      value: (1),
      expression: "1",
      modifiers: {
        "bottom": true
      }
    }]
  }, [_c('v-text', [_vm._v("\n          Согласие действует бессрочно и прекращается при наступлении одного\n          из следующих событий: отзыв согласия на обработку персональных\n          данных или достижение цели обработки персональных данных.\n        ")])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "margin",
      rawName: "v-margin.bottom",
      value: (1),
      expression: "1",
      modifiers: {
        "bottom": true
      }
    }]
  }, [_c('v-text', [_vm._v("\n          Я оставляю за собой право отозвать свое согласие посредством\n          составления соответствующего письменного документа, который может\n          быть направлен мной в адрес Оператора по электронной почте:\n          "), _c('v-link', {
    attrs: {
      "target": "_blank",
      "to": "mailto:support@unirate24.ru"
    }
  }, [_vm._v("\n            support@unirate24.ru\n          ")]), _vm._v("\n          или заказным письмом с уведомлением о вручении по адресу: 620041, г.\n          Екатеринбург, ул. Красина 7, а/я 28.\n        ")], 1)], 1), _vm._v(" "), (_vm.showForm && _vm.state === 0) ? _c('div', [_c('v-form', {
    ref: "form",
    attrs: {
      "validate": _vm.validateForm,
      "readonly": false
    },
    on: {
      "submit": _vm.handleSubmit
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(api) {
        return [_c('form-phone-verify', {
          directives: [{
            name: "margin",
            rawName: "v-margin.bottom",
            value: (2),
            expression: "2",
            modifiers: {
              "bottom": true
            }
          }],
          attrs: {
            "disabled": false,
            "loader": false,
            "invalidCode": !!api.getError('smscode'),
            "invalidPhone": !!api.getError('phone')
          },
          on: {
            "send-code": function($event) {
              _vm.handleSendCode(api.getValue('phone'))
            },
            "confirm-code": function($event) {
              _vm.handleConfirmCode(api.getValues())
            },
            "reset": function($event) {
              _vm.handleReset(api)
            }
          }
        }), _vm._v(" "), _c('v-row', {
          attrs: {
            "justifyContent": "between"
          }
        }, [_c('v-col', {
          attrs: {
            "xs": "5"
          }
        }, [_c('v-button', {
          attrs: {
            "disabled": _vm.disabled || _vm.isSending,
            "type": "submit",
            "primary": "",
            "block": ""
          },
          on: {
            "click": function () { return (_vm.accept = true); }
          }
        }, [_vm._v("\n                  Подтверждаю\n                ")])], 1), _vm._v(" "), _c('v-col', {
          attrs: {
            "xs": "5"
          }
        }, [_c('v-button', {
          attrs: {
            "type": "submit",
            "disabled": _vm.isSending,
            "block": ""
          },
          on: {
            "click": function () { return (_vm.accept = false); }
          }
        }, [_vm._v("\n                  Не Подтверждаю\n                ")]), _vm._v(" "), _c('div', {
          directives: [{
            name: "margin",
            rawName: "v-margin.bottom",
            value: (1),
            expression: "1",
            modifiers: {
              "bottom": true
            }
          }, {
            name: "margin",
            rawName: "v-margin.top",
            value: (2),
            expression: "2",
            modifiers: {
              "top": true
            }
          }]
        }, [_c('v-text', {
          attrs: {
            "type": "subheadling"
          }
        }, [_vm._v("\n                    Пожалуйста укажите причину\n                  ")])], 1), _vm._v(" "), _c('div', {
          directives: [{
            name: "margin",
            rawName: "v-margin.bottom",
            value: (2),
            expression: "2",
            modifiers: {
              "bottom": true
            }
          }]
        }, [_c('v-form-radio', {
          directives: [{
            name: "margin",
            rawName: "v-margin.bottom",
            value: (2),
            expression: "2",
            modifiers: {
              "bottom": true
            }
          }],
          attrs: {
            "field": "declineReason",
            "data": 0,
            "label": "Я не понимаю о чем речь"
          }
        }), _vm._v(" "), _c('v-form-radio', {
          directives: [{
            name: "margin",
            rawName: "v-margin.bottom",
            value: (2),
            expression: "2",
            modifiers: {
              "bottom": true
            }
          }],
          attrs: {
            "field": "declineReason",
            "data": 1,
            "label": "Я не являюсь указанным лицом"
          }
        }), _vm._v(" "), _c('v-form-radio', {
          directives: [{
            name: "margin",
            rawName: "v-margin.bottom",
            value: (2),
            expression: "2",
            modifiers: {
              "bottom": true
            }
          }],
          attrs: {
            "field": "declineReason",
            "data": 2,
            "label": "Не актуально"
          }
        })], 1)], 1)], 1), _vm._v(" "), _c('div', {
          directives: [{
            name: "margin",
            rawName: "v-margin.bottom",
            value: (4),
            expression: "4",
            modifiers: {
              "bottom": true
            }
          }, {
            name: "margin",
            rawName: "v-margin.top",
            value: (2),
            expression: "2",
            modifiers: {
              "top": true
            }
          }]
        }, [(_vm.serverError) ? _c('div', {
          directives: [{
            name: "padding",
            rawName: "v-padding.top",
            value: (1),
            expression: "1",
            modifiers: {
              "top": true
            }
          }]
        }, [_c('v-text', {
          attrs: {
            "danger": ""
          }
        }, [_vm._v("\n                  " + _vm._s(_vm.serverError) + "\n                ")])], 1) : _vm._e()])]
      }
    }])
  })], 1) : _c('div', {
    directives: [{
      name: "text-align",
      rawName: "v-text-align.center",
      modifiers: {
        "center": true
      }
    }]
  }, [_c('v-text', {
    attrs: {
      "type": "subheadling",
      "bold": ""
    }
  }, [_vm._v("\n          Согласие было " + _vm._s(_vm.decision) + ". " + _vm._s(_vm.moment().format('DD.MM.YYYY')) + "\n        ")])], 1)])])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-72a83216","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/crv/CRV.vue
// module id = 834
// module chunks = 0